import React from 'react';
export function DownloadLiner24() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 13.9462V19.0541C21 19.5702 20.7893 20.0651 20.4142 20.4301C20.0391 20.795 19.5304 21 19 21H5C4.46957 21 3.96086 20.795 3.58579 20.4301C3.21071 20.0651 3 19.5702 3 19.0541L3 13.9462M7.13502 9.81133L11.9998 14.676M11.9998 14.676L16.8647 9.81133M11.9998 14.676L11.9998 3",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}